import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ICreateAppointmentPaymentReportsProps {
  authorizationDateEnd: Date;
  authorizationDateInit: Date;
  limit?: number;
  order?: 'ASC' | 'DESC';
  page?: number;
  sort?: 'createdAt';
}

export const createAppointmentPaymentsReportFileService = async ({
  authorizationDateEnd,
  authorizationDateInit,
  limit,
  order,
  page,
  sort,
}: ICreateAppointmentPaymentReportsProps): Promise<string> => {
  const { data } = await jhsfBookingsApi.post<Blob>(
    '/appointments/payments/reports/xlsx',
    {
      authorizationDateEnd,
      authorizationDateInit,
    },
    {
      responseType: 'blob',
      params: {
        limit,
        order,
        page,
        sort,
      },
    },
  );

  const fileUrl = URL.createObjectURL(data);

  return fileUrl;
};
